import {
  Input,Output,SimpleChanges,OnChanges,DoCheck,ViewChild,
  EventEmitter,AfterViewInit,
  Component,
  OnInit
} from '@angular/core';
import {ElementRef} from '@angular/core';
import {DatePickerComponent} from 'ng2-jalali-date-picker';
import * as moment from 'jalali-moment';
import {SessionDateVM} from "../../../models/SessionDateVM.model";
import {OrderBagService} from "../../../services/orderbag/orderbag.service";
import {CompanyService} from "../../../services/company-service/company-service";
declare var $: any;
var parent;
@Component({

  selector: 'rw-date-picker-v2',  // <home></home>

  styles: [require('./date-picker-v2.component.css')],

  template: require('./date-picker-v2.component.html'),
})
export class PersianDatePickerV2Component implements OnInit,OnChanges,DoCheck,AfterViewInit {
  @ViewChild('dayPicker') datePicker:DatePickerComponent;
  @ViewChild('dayPickerModal') el:ElementRef;
  @Input()minDate:Date;
  public minDateM;
  any;
  @Input()maxDate:Date;
  @Input()availableDates:SessionDateVM[] ;
  @Input()selectedDate:Date;
  @Input()placeholderText:string='تاریخ';
  @Output()selectedDateChanged:EventEmitter<Date> = new EventEmitter();
  public tempDate:Date;
  public viewInited:boolean=false;
  public showCalendar:boolean=true;

  //OR if you have initial value you could use following code

  public dateObject:any = moment();
  public config:any;
  public configModal:any;

  @Input()
  public isModal:boolean=false;
  /**
   * TypeScript public modifiers
   */
  constructor(private orderBagService: OrderBagService,
              private companyService: CompanyService
              ) {

    parent = this;
    this.config = {

      isDayDisabledCallback: this.isDayDisabledCallback,
      dayBtnCssClassCallback:this.dayBtnCssClassCallback


    };


    //this.configModal = {
    //
    //  isDayDisabledCallback: this.isDayDisabledCallback,
    //  appendTo:this.el,
    //  allowMultiSelect:true
    //
    //
    //};
  }

  public ngOnInit() {
    this.minDate = new Date();
    this.minDateM = moment('1396-08-22', 'jYYYY,jMM,jDD');


  }

  ngOnChanges(changes:SimpleChanges):void {

    let parent = this;
    if(changes.availableDates)
    parent.updateCaledar()

  }
  ngAfterViewInit()
  {
   if(this.isModal)
    this.configModal = {

      isDayDisabledCallback: this.isDayDisabledCallback,
      appendTo:this.el.nativeElement



    };
    this.viewInited=true;

  }
  ngDoCheck() {
    if (this.dateObject != this.tempDate) {
      this.tempDate = this.dateObject;
      this.dateObjectChanged(this.dateObject);
    }
  }

  updateCaledar() {
  let parent=this;
    //$('.dp-calendar-nav-container-right').click();
    setTimeout(function(){
     parent.showCalendar=false;
      setTimeout(function(){
       parent.showCalendar=true;
      },1)

    },1)

  }
  noDayAvailable(date:any)
  {
    return false;
  }

  isDayDisabledCallback(date:any) {


    let isInList =parent.isInList(parent.availableDates,date);

    if (isInList)
    {
      return false;
    }
    else
      return true;


  }
  dayBtnCssClassCallback(date:any){

    let isInList =parent.isInList(parent.availableDates,date);
    if (isInList)
    {
      if( isInList.capacity<1)return 'is-full-date';
    }
    else
      return '';
  }

  public isInList(dateList:SessionDateVM[], date:Date):SessionDateVM {

    let isInList = null;
    if (dateList) {

      if(date && !date.getDate)
      date=this.convertMomentToDate(date);

      let isLogged = false;

      dateList.forEach((ado:SessionDateVM)=> {

        let ad=new Date( ado.startDate); /// not work on safari !!

        if(!this.isDateValid(ad))
          ad=new Date( ado.startDate.replace(/-/g, "/"));


        //log into server if had bug
        if(!this.isDateValid(ad) )
        {
          if(!isLogged)
          {
            isLogged = true;
            this.logIntoServer();
          }
        }


        ad=this.correctTimeZone(ad);

        if (ad.getDate() == date.getDate() &&
          ad.getMonth() == date.getMonth() &&
          ad.getFullYear() == date.getFullYear()) {
          isInList = ado;
          return
        }
      });

    }
    return isInList;
  }

  public dateObjectChanged(dateObject:any):void {
    if (this.dateObjectIsValid(dateObject)) {
      this.selectedDate = this.convertMomentToDate(dateObject);

      this.selectedDateChanged.emit(this.selectedDate);
    }
    else {
      this.dateObject = null;
      this.selectedDate = null;
      this.selectedDateChanged.emit(null);
      // this.datePicker.api.open();
    }
  }

  public dateObjectIsValid(dateObject:any):boolean {
    if (dateObject) {
      if (dateObject.toDate()) {
        let item= this.isInList(this.availableDates, dateObject.toDate());
        if(item)
        return true;
        else
        return false;
        //  return !(this.isDayDisabledCallback(dateObject))

      }
    }
    return false;
  }

  public convertMomentToDate(dateObject:any):Date {
    let retDate:Date;
    retDate = dateObject.toDate();
    retDate.setHours(12, 0, 0);
    //retDate=this.correctTimeZone(retDate);
    return retDate;
  }

  public correctTimeZone(date:Date) {

    var aestTime = date.toLocaleString("en-US", {timeZone: "Asia/Tehran"});
    date = new Date(aestTime);

    //var n = date.getTimezoneOffset();
    date.setHours(12, 0, 0);

    return date;

  }


  public isDateValid(date){
    if (isNaN(date.getTime())) {

    }
    else {
      return true;
    }
  }

  public moveToDate(date)
  {
    let mDate = moment(new Date(date));
    this.datePicker.api.moveCalendarTo(mDate);
  }

  public logIntoServer()
  {

    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName  = navigator.appName;
    var fullVersion  = ''+parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion,10);
    var nameOffset,verOffset,ix;

// In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
      browserName = "Opera";
      fullVersion = nAgt.substring(verOffset+6);
      if ((verOffset=nAgt.indexOf("Version"))!=-1)
        fullVersion = nAgt.substring(verOffset+8);
    }
// In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
      browserName = "Microsoft Internet Explorer";
      fullVersion = nAgt.substring(verOffset+5);
    }
// In Chrome, the true version is after "Chrome"
    else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
      browserName = "Chrome";
      fullVersion = nAgt.substring(verOffset+7);
    }
// In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
      browserName = "Safari";
      fullVersion = nAgt.substring(verOffset+7);
      if ((verOffset=nAgt.indexOf("Version"))!=-1)
        fullVersion = nAgt.substring(verOffset+8);
    }
// In Firefox, the true version is after "Firefox"
    else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
      browserName = "Firefox";
      fullVersion = nAgt.substring(verOffset+8);
    }
// In most other browsers, "name/version" is at the end of userAgent
    else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) <
      (verOffset=nAgt.lastIndexOf('/')) )
    {
      browserName = nAgt.substring(nameOffset,verOffset);
      fullVersion = nAgt.substring(verOffset+1);
      if (browserName.toLowerCase()==browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }
// trim the fullVersion string at semicolon/space if present
    if ((ix=fullVersion.indexOf(";"))!=-1)
      fullVersion=fullVersion.substring(0,ix);
    if ((ix=fullVersion.indexOf(" "))!=-1)
      fullVersion=fullVersion.substring(0,ix);

    majorVersion = parseInt(''+fullVersion,10);
    if (isNaN(majorVersion)) {
      fullVersion  = ''+parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion,10);
    }

    let log =
      "Invalid Date is Appear is Below System :"
      +"Company Key_Url : " + this.companyService.getBaseUrl() + "--"
      +'Browser name  = '+browserName+'<br>'
      +'Full version  = '+fullVersion+'<br>'
      +'Major version = '+majorVersion+'<br>'
      +'navigator.appName = '+navigator.appName+'<br>'
      +'navigator.userAgent = '+navigator.userAgent+'<br>'


    if(log)
      this.orderBagService.logIntoServer(log);

  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/shared/date-picker-v2/date-picker-v2.component.ts